<template>
    <div class="agent-page">
        <!-- 页面头部 -->
        <div class="page-header">
            <div class="header-left">
                <h2 class="page-title">{{ pageTitle }}</h2>
                <h2 class="sub-title">{{ subTitle }}</h2>
            </div>
            <el-button type="primary" icon="el-icon-arrow-left" @click="handleBack">返回</el-button>
        </div>

        <!-- 表单内容 -->
        <div class="content-wrap">
            <el-form ref="projectForm" :model="formData" :rules="isReadOnly ? {} : formRules" label-width="140px"
                class="project-form">
                <el-row :gutter="30">
                    <!-- 左列 -->
                    <el-col :span="12">
                        <!-- 邀请书名称 -->
                        <el-form-item label="邀请书名称:" prop="bidInviteName" required>
                            <el-input v-model="formData.bidInviteName" placeholder="请输入邀请书名称" :disabled="isReadOnly"
                                class="form-input" />
                        </el-form-item>

                        <!-- 项目编码 -->
                        <el-form-item label="项目编码:" prop="projectCode">
                            <el-input v-model="formData.projectCode" disabled class="form-input" />
                        </el-form-item>

                        <!-- 招标项目名称 -->
                        <el-form-item label="招标项目名称:" prop="projectName">
                            <el-input v-model="formData.projectName" disabled class="form-input" />
                        </el-form-item>

                        <!-- 邀请书发出时间 -->
                        <el-form-item label="邀请书发出时间:" prop="bidInviteIssueTime" required>
                            <app-date-picker v-model="formData.bidInviteIssueTime" type="datetime" placeholder="选择日期时间"
                                :disabled="isReadOnly" class="form-date-picker" />
                        </el-form-item>

                        <!-- 选择标段 -->
                        <el-form-item label="选择标段:" prop="selectSection" required>
                            <el-select v-model="formData.selectSection" placeholder="请选择标段" :disabled="isReadOnly"
                                class="form-select">
                                <el-option v-for="item in bidSectionList" :key="item.bidSectionCode"
                                    :label="item.bidSectionName" :value="item.bidSectionCode" />
                            </el-select>
                        </el-form-item>
                    </el-col>

                    <!-- 右列 -->
                    <el-col :span="12">
                        <!-- 选择邀请单位 -->
                        <el-form-item label="选择邀请单位:" prop="selectInvitingUnit" required>
                            <el-select v-model="formData.selectInvitingUnit" placeholder="输入名称搜索邀请单位"
                                :disabled="isReadOnly" class="form-select invite-unit-select" multiple collapse-tags
                                filterable remote reserve-keyword
                                :remote-method="searchBidders"
                                :loading="bidderLoading"
                                popper-class="invite-unit-select-dropdown">
                                <el-option v-for="item in bidderArray" :key="item.bidderCode" :label="item.bidderName"
                                    :value="item.bidderCode" />
                            </el-select>
                        </el-form-item>

                        <!-- 文件获取时间 -->
                        <el-form-item label="文件获取时间:" prop="biddingDocumentAcquisitionStartTime" required>
                            <app-date-picker v-model="formData.biddingDocumentAcquisitionStartTime" type="datetime"
                                placeholder="选择日期时间" :disabled="isReadOnly" class="form-date-picker" />
                        </el-form-item>

                        <!-- 文件递交截止时间 -->
                        <el-form-item label="文件递交截止时间:" prop="bidDocumentSubmissionDeadline" required>
                            <app-date-picker v-model="formData.bidDocumentSubmissionDeadline" type="datetime"
                                placeholder="选择日期时间" :disabled="isReadOnly" class="form-date-picker" />
                        </el-form-item>

                        <!-- 回函截止时间 -->
                        <el-form-item label="回函截止时间:" prop="bidInviteEndTime" required>
                            <app-date-picker v-model="formData.bidInviteEndTime" type="datetime" placeholder="选择日期时间"
                                :disabled="isReadOnly" class="form-date-picker" />
                        </el-form-item>
                    </el-col>
                </el-row>

                <!-- 附件 - 跨两列 -->
                <el-row :gutter="30">
                    <el-col :span="24">
                        <el-form-item label="附件:" class="attachment-item">
                            <div class="attachment-section">
                                <el-button v-if="!isReadOnly" type="primary" class="select-file-btn"
                                    @click="selectFile">
                                    选取文件
                                </el-button>
                                <input ref="fileInput" type="file" multiple style="display: none"
                                    @change="handleFileSelect">
                            </div>

                            <!-- 文件列表表格 -->
                            <div class="file-table-container">
                                <el-table :data="fileList" class="file-table" empty-text="暂无数据">
                                    <el-table-column prop="fileName" label="文件名" show-overflow-tooltip />
                                    <el-table-column prop="fileType" label="文件类型" width="120" />
                                    <el-table-column label="操作" width="100" v-if="!isReadOnly">
                                        <template slot-scope="scope">
                                            <el-button type="text" size="small" @click="removeFile(scope.$index)"
                                                class="delete-btn">
                                                删除
                                            </el-button>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                        </el-form-item>
                    </el-col>
                </el-row>

                <!-- 邀请书内容 - 跨两列 -->
                <el-row :gutter="30">
                    <el-col :span="24">
                        <el-form-item label="邀请书内容:" prop="bidInviteIssueContent">
                            <RichTextEditor v-model="formData.bidInviteIssueContent" :height="400"
                                placeholder="请输入邀请书内容..." toolbar-type="default" :disabled="isReadOnly" />
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>

            <!-- 操作按钮 -->
            <div class="action-buttons" v-if="!isReadOnly">
                <el-button type="primary" class="action-btn" @click="saveDraft">暂存</el-button>
                <el-button type="primary" class="action-btn" @click="submitForm">提交</el-button>
            </div>

            <!-- 投标人响应列表 - 仅在编辑和详情时显示 -->
            <div v-if="type !== 'new_change' && selectedBidders.length > 0" class="bidder-response-section">
                <h3 class="section-title">投标人响应情况</h3>
                <el-table :data="selectedBidders" border class="bidder-response-table">
                    <el-table-column type="index" label="序号" width="60" align="center" />
                    <el-table-column prop="bidderName" label="投标人名称" show-overflow-tooltip />
                    <el-table-column prop="bidderOrgCode" label="组织机构代码" width="150" />
                    <el-table-column label="响应状态" width="100" align="center">
                        <template slot-scope="scope">
                            <el-tag :type="getBidderStatusType(scope.row.status)">
                                {{ getBidderStatusText(scope.row.status) }}
                            </el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="bidderReplyContent" label="回复内容" show-overflow-tooltip />
                    <el-table-column prop="bidderReplyTime" label="回复时间" width="160" align="center" />
                </el-table>
            </div>
        </div>
    </div>
</template>

<script>
import RichTextEditor from '@/components/common/RichTextEditor.vue'
import { initInvitationLetter, bidderList, addInvitationLetter } from '@/api/modules/invitationLetter'
import { timeUtils } from '@/utils/base'
import { doFileUpload } from '@/utils/upload/fileUploadHelper'
import { invitationLetterDetail } from '@/api/modules/invitationLetter'
import { getFileList } from '@/api/modules/base'
import { getProjectDetail } from '@/api/modules/agent'
export default {
    name: 'AddTenderAnnouncement',
    components: {
        RichTextEditor
    },
    data() {
        return {
            type: '',
            bidInviteCode: '',
            projectCode: '',
            bidderArray: [], // 所有投标单位（用于下拉选择）
            selectedBidders: [], // 当前邀请书已选中的投标单位
            bidSectionList: [], // 标段列表
            projectDetail: {},
            // 搜索相关
            bidderLoading: false,
            formData: {
                bidInviteName: '', // 邀请书名称
                projectCode: '', // 项目编码
                projectName: '', // 招标项目名称
                selectSection: '', // 选择标段
                selectInvitingUnit: [], // 选择邀请单位（多选，存储 bidderCode 数组）
                biddingDocumentAcquisitionStartTime: '', // 文件获取时间
                bidDocumentSubmissionDeadline: '', // 文件递交截止时间
                bidInviteEndTime: '', // 回函截止时间
                bidInviteIssueTime: '', // 邀请书发出时间
                bidInviteIssueContent: '' // 邀请书内容
            },
            fileList: [], // 文件列表
            fileGuid: '',
            formRules: {
                bidInviteName: [
                    { required: true, message: '请输入邀请书名称' }
                ],
                selectSection: [
                    { required: true, message: '请选择标段' }
                ],
                selectInvitingUnit: [
                    { required: true, message: '请选择邀请单位' }
                ],
                biddingDocumentAcquisitionStartTime: [
                    { required: true, message: '请选择文件获取时间' }
                ],
                bidDocumentSubmissionDeadline: [
                    { required: true, message: '请选择文件递交截止时间' }
                ],
                bidInviteEndTime: [
                    { required: true, message: '请选择回函截止时间' }
                ],
                bidInviteIssueTime: [
                    { required: true, message: '请选择邀请书发出时间' }
                ]
            }
        }
    },
    computed: {
        // 是否只读模式（详情页面）
        isReadOnly() {
            return this.type === 'detail'
        },
        // 页面标题
        pageTitle() {
            if (this.projectDetail.projectType) {
                const projectTypeName = this.$getProjectTypeName ? this.$getProjectTypeName(this.projectDetail.projectType) : ''
                return `${projectTypeName}--招标项目编号：${this.projectDetail.projectCode || ''} 招标项目名称：${this.projectDetail.projectName || ''}`
            }
            return ''
        },
        // 副标题
        subTitle() {
            if (this.type === 'detail') return '邀请书详情'
            if (this.type === 'edit') return '编辑邀请书'
            return '新增邀请书'
        }
    },
    watch: {
        // 标段变更时，重新加载投标人列表
        'formData.selectSection'(newVal, oldVal) {
            if (newVal === oldVal) return
            if (this.isReadOnly) return
            this.searchBidders('')
        }
    },
    mounted() {
        this.type = this.$route.query.type
        this.projectCode = this.$route.query.projectCode
        this.bidInviteCode = this.$route.query.bidInviteCode || ''
        this.loadProjectDetail()
        this.initInvitationLetter(this.projectCode)
        if (this.type !== 'new_change') {
            // 编辑/详情模式：先获取详情（包含已选中的单位），再获取所有单位列表
            this.getInvitationLetterDetail(this.bidInviteCode)
        } else {
            // 新增模式：直接获取所有单位列表
            this.searchBidders('')
            // 时间戳+随机数
            this.fileGuid = new Date().getTime() + Math.random().toString().substr(2, 5)
        }
    },
    methods: {
        // 获取项目详情
        async loadProjectDetail() {
            const res = await getProjectDetail({ projectCode: this.projectCode })
            if (res.code === 200) {
                this.projectDetail = res.data
            } else {
                this.$message.error('获取项目详情失败')
            }
        },
        //获取详情
        getInvitationLetterDetail(bidInviteCode) {
            invitationLetterDetail({ bidInviteCode: bidInviteCode }).then(res => {
                if (res.code === 200) {
                    const data = res.data
                    this.formData.bidInviteName = data.bidInviteName
                    this.bidSectionList = data.bidSectionList || []
                    // 保存当前邀请书已选中的投标单位
                    this.selectedBidders = data.bidderList || []
                    // 找到选中的标段
                    const selectedSection = data.bidSectionList?.find(item => item.isSelected === 1)
                    this.formData.selectSection = selectedSection ? selectedSection.bidSectionCode : ''
                    // 设置选中的投标单位（只存储 bidderCode）
                    this.formData.selectInvitingUnit = data.bidderList?.map(item => item.bidderCode) || []
                    this.formData.biddingDocumentAcquisitionStartTime = data.biddingDocumentAcquisitionStartTime ? new Date(data.biddingDocumentAcquisitionStartTime) : ''
                    this.formData.bidDocumentSubmissionDeadline = data.bidDocumentSubmissionDeadline ? new Date(data.bidDocumentSubmissionDeadline) : ''
                    this.formData.bidInviteEndTime = data.bidInviteEndTime ? new Date(data.bidInviteEndTime) : ''
                    this.formData.bidInviteIssueTime = data.bidInviteIssueTime ? new Date(data.bidInviteIssueTime) : ''
                    this.fileGuid = data.fileGuid
                    this.formData.bidInviteIssueContent = data.bidInviteIssueContent



                    this.getFileDownloadList(data.fileGuid)
                    // 获取所有投标单位列表搜索用
                    this.searchBidders('')
                } else {
                    this.$message.error(res.message || '获取详情失败')
                }
            }).catch(error => {
                this.$message.error('获取详情失败')
            }).finally(() => {
            })
        },

        /**
        * 获取文件下载列表
        */
        getFileDownloadList(fileGuid) {
            if (!fileGuid) {
                this.fileList = []
                return
            }
            const res = getFileList(fileGuid)
            if (res.code == 200) {
                if (res.data.length === 0) {
                    this.fileList = []
                    return
                }
                this.fileList = res.data.map(item => ({
                    fileName: item.fileName,
                    fileType: this.getFileType(item.fileName),
                    uploadTime: '',
                    fileId: item.fileId,
                    fileUrl: item.fileUrl,
                    fileExtension: item.fileExtension,
                    fileSize: item.fileSize
                }))
            } else {
                // this.$message.error(res.msg)
            }
        },
        // 初始化投标邀请书
        initInvitationLetter(projectCode) {
            initInvitationLetter(projectCode).then(res => {
                if (res.code === 200) {
                    this.bidSectionList = res.data.bidSectionList || []
                    this.formData.projectCode = res.data.projectCode;
                    this.formData.projectName = res.data.projectName;
                } else {
                    this.$message.error(res.message || '初始化投标邀请书失败')
                }
            })

        },
        // 远程搜索投标单位（支持模糊查询）
        searchBidders(query) {
            if (this.bidderLoading) return
            this.bidderLoading = true
            const params = {
                bidderName: query || '',
                bidSectionCode: this.formData.selectSection || '',
                pageNum: 1,
                pageSize: 50,
                stage: 0
            }
            bidderList(params).then(res => {
                if (res.code === 200) {
                    const records = res.data.records || []
                    // 确保已选中的单位始终在列表中
                    const bidderMap = new Map()
                    records.forEach(item => {
                        bidderMap.set(item.bidderCode, item)
                    })
                    this.selectedBidders.forEach(item => {
                        if (!bidderMap.has(item.bidderCode)) {
                            bidderMap.set(item.bidderCode, item)
                        }
                    })
                    this.bidderArray = Array.from(bidderMap.values())
                } else {
                    this.$message.error(res.message || '获取投标单位列表失败')
                }
            }).catch(() => {
                this.$message.error('获取投标单位列表失败')
            }).finally(() => {
                this.bidderLoading = false
            })
        },

        // 选择文件
        selectFile() {
            this.$refs.fileInput.click()
        },

        // 处理文件选择
        async handleFileSelect(event) {
            const files = event.target.files
            if (!files || files.length === 0) return
            for (let i = 0; i < files.length; i++) {
                const file = files[i]
                // 设置文件类型
                file.fileType = 'invitation-att'
                // 添加到列表，显示上传中状态
                const fileItem = {
                    fileName: file.name,
                    fileType: this.getFileType(file.name),
                    uploadTime: timeUtils.formatTime(new Date()),
                    uploading: true,
                    uploadProgress: 0
                }
                this.fileList.push(fileItem)
                const fileIndex = this.fileList.length - 1

                try {
                    // 调用上传方法
                    const result = await doFileUpload(file, {
                        fileBindId: this.fileGuid,
                        onProgress: (progress) => {
                            this.fileList[fileIndex].uploadProgress = progress
                        },
                        onSuccess: (uploadResult) => {
                            // 上传成功，更新文件信息
                            this.fileList[fileIndex].uploading = false
                            this.fileList[fileIndex].uploadProgress = 100
                            this.fileList[fileIndex].fileGuid = uploadResult.fileGuid
                            this.fileList[fileIndex].uploadFileId = uploadResult.uploadFileId
                            this.fileList[fileIndex].filePath = uploadResult.filePath
                            this.$message.success(`${file.name} 上传成功`)
                        },
                        onError: (error) => {
                            // 上传失败，从列表移除
                            this.fileList.splice(fileIndex, 1)
                            this.$message.error(`${file.name} 上传失败: ${error.message}`)
                        }
                    })
                } catch (error) {
                    // 上传异常，从列表移除
                    this.fileList.splice(fileIndex, 1)
                    this.$message.error(`${file.name} 上传失败`)
                    console.error('文件上传错误:', error)
                }
            }

            // 清空input值，允许重复选择同一文件
            event.target.value = ''
        },

        // 获取文件类型
        getFileType(fileName) {
            const ext = fileName.split('.').pop().toLowerCase()
            const typeMap = {
                'pdf': 'PDF',
                'doc': 'Word',
                'docx': 'Word',
                'xls': 'Excel',
                'xlsx': 'Excel',
                'ppt': 'PowerPoint',
                'pptx': 'PowerPoint',
                'jpg': '图片',
                'jpeg': '图片',
                'png': '图片',
                'gif': '图片',
                'txt': '文本',
                'zip': '压缩包',
                'rar': '压缩包'
            }
            return typeMap[ext] || '其他'
        },


        // 删除文件
        removeFile(index) {
            this.fileList.splice(index, 1)
        },

        // 暂存
        saveDraft() {
            this.$refs.projectForm.validate((valid) => {
                if (valid) {
                    this.submitData(0)
                } else {
                    this.$message.error('请填写必填项')
                }
            })
        },

        // 提交表单
        submitForm() {
            this.$refs.projectForm.validate((valid) => {
                if (valid) {
                    this.submitData(9)
                } else {
                    this.$message.error('请填写必填项')
                }
            })
        },

        // 提交数据到接口
        submitData(status) {
            const selectedSection = this.bidSectionList.find(item => item.bidSectionCode === this.formData.selectSection)
            const selectedBidders = this.bidderArray.filter(item =>
                this.formData.selectInvitingUnit.includes(item.bidderCode)
            )
            const params = {
                bidDocumentSubmissionDeadline: timeUtils.formatTime(this.formData.bidDocumentSubmissionDeadline),
                bidInviteEndTime: timeUtils.formatTime(this.formData.bidInviteEndTime),
                bidInviteName: this.formData.bidInviteName,
                bidSectionList: selectedSection ? [selectedSection] : [],
                bidderList: selectedBidders,
                biddingDocumentAcquisitionStartTime: timeUtils.formatTime(this.formData.biddingDocumentAcquisitionStartTime),
                fileGuid: this.fileGuid,
                projectCode: this.formData.projectCode,
                projectName: this.formData.projectName,
                status: status, // 0：暂存、9：发布
                bidInviteIssueTime: timeUtils.formatTime(this.formData.bidInviteIssueTime),
                bidInviteIssueContent: this.formData.bidInviteIssueContent
            }
            if (this.type !== 'new_change') {
                params.bidInviteCode = this.bidInviteCode
            }
            addInvitationLetter(params).then(res => {
                if (res.code === 200) {
                    this.$message.success(status === 0 ? '暂存成功' : '发布成功')
                    // 返回上一页
                    setTimeout(() => {
                        this.$router.go(-1)
                    }, 1000)
                } else {
                    this.$message.error(res.msg || (status === 0 ? '暂存失败' : '发布失败'))
                }
            }).catch(err => {
                this.$message.error('操作失败，请稍后重试')
                console.error(err)
            })
        },

        // 返回上一页
        handleBack() {
            this.$router.back()
        },

        // 获取投标人响应状态文本
        getBidderStatusText(status) {
            const statusMap = {
                0: '未响应',
                1: '已同意',
                2: '已拒绝'
            }
            return statusMap[status] || '未响应'
        },

        // 获取投标人响应状态标签类型
        getBidderStatusType(status) {
            const typeMap = {
                0: 'info',
                1: 'success',
                2: 'danger'
            }
            return typeMap[status] || 'info'
        }
    }
}
</script>

<style lang="less" scoped>
// 引入极简灰度配色公共样式
@import '@/styles/minimal-gray-theme.less';

.agent-page {
    .apply-minimal-gray-theme();
}

// 页面头部
.page-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: 20px;
    gap: 20px;
    text-align: start;

    .header-left {
        display: flex;
        flex-direction: column;
        align-items: start;
    }

    .page-title {
        font-size: 16px;
        font-weight: 600;
        color: @gray-700;
        margin: 0;
        line-height: 1.5;
        position: relative;
        padding-left: 10px;


        &::before {
            content: '';
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            width: 3px;
            height: 16px;
            background: @primary-color;
            border-radius: 2px;
        }
    }

    .sub-title {
        font-size: 18px;
        font-weight: 600;
        color: @gray-700;
        margin: 10px 0 0 0;
        padding-left: 10px;
        position: relative;

        &::before {
            content: '';
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            width: 3px;
            height: 16px;
            background: @gray-700;
            border-radius: 2px;
        }
    }
}

// 内容区域
.content-wrap {
    background: #fff;
    border-radius: 4px;
    box-shadow: @shadow-sm;
    padding: 30px;
}

// 表单样式
.project-form {
    .el-form-item {
        margin-bottom: 20px;

        .el-form-item__label {
            color: @gray-700;
            font-weight: 500;
        }

        &.is-required .el-form-item__label::before {
            color: @error-color;
        }
    }
}

// 输入框样式
.form-input,
.form-select,
.form-date-picker {
    width: 100%;

    /deep/ .el-input__inner {
        border: 1px solid @gray-300;
        border-radius: 4px;
        background-color: #fff;
        color: @gray-700;

        &:focus {
            border-color: @primary-color;
        }

        &::placeholder {
            color: @gray-400;
        }

        &:disabled {
            background-color: @gray-100;
            border-color: @gray-200;
            color: @gray-500;
        }
    }
}

// 附件区域
.attachment-item {
    .el-form-item__label::before {
        display: none !important;
    }
}

.attachment-section {
    margin-bottom: 15px;
}

.select-file-btn {
    background-color: @primary-color;
    border-color: @primary-color;

    &:hover {
        background-color: @primary-hover;
        border-color: @primary-hover;
    }
}

.file-table-container {
    margin-top: 10px;
}

.file-table {
    border: 1px solid @gray-200;
    border-radius: 4px;

    /deep/ .el-table__header {
        th {
            background-color: @gray-100;
            color: @gray-700;
            font-weight: 600;
        }
    }

    .delete-btn {
        color: @error-color;

        &:hover {
            color: @error-color;
            opacity: 0.8;
        }
    }
}

// 操作按钮
.action-buttons {
    text-align: center;
    margin-top: 30px;
    padding-top: 20px;
    border-top: 1px solid @gray-200;

    .action-btn {
        background-color: @primary-color;
        border-color: @primary-color;
        padding: 12px 30px;
        margin: 0 10px;

        &:hover {
            background-color: @primary-hover;
            border-color: @primary-hover;
        }
    }
}

// 投标人响应列表
.bidder-response-section {
    margin-top: 30px;
    padding-top: 20px;
    border-top: 1px solid @gray-200;

    .section-title {
        font-size: 16px;
        font-weight: 600;
        color: @gray-700;
        margin: 0 0 15px 0;
        padding-left: 10px;
        position: relative;

        &::before {
            content: '';
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            width: 3px;
            height: 16px;
            background: @gray-700;
            border-radius: 2px;
        }
    }
}

.bidder-response-table {
    border: 1px solid @gray-200;
    border-radius: 4px;

    /deep/ .el-table__header {
        th {
            background-color: @gray-100;
            color: @gray-700;
            font-weight: 600;
        }
    }
}

// 下拉框中远程搜索样式（popper 通过 portal 渲染到 body，使用 popper-class 定位）
/deep/ .invite-unit-select-dropdown .el-select-dropdown__list {
    padding-bottom: 0;
}
</style>
